export default "__VITE_ASSET__Bg7WD6mC__"